import React, { useEffect, useState } from 'react';
import {
  Disclosure,
  // DisclosureButton,
  // DisclosurePanel,
} from '@headlessui/react';
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import logo from '../images/logo/jvx-studio-logo.svg';
// import { Link } from 'src/components/Link';
// import SigninAccountButton from './SigninAccountButton';
// import StoreButton from './StoreButton';
import { usePageContext } from './PageContext';

// const navigation = [
//   {
//     name: 'How it works',
//     href: '/#get-started-with-confidence',
//     current: false,
//   },
//   { name: 'Our guides', href: '/#our-builds', current: false },
//   { name: 'Build gallery', href: '/#gallery', current: false },
// ];

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ');
// }

export default function NavBar() {
  const [scrolledFromTop, setScrolledFromTop] = useState(false);
  const pageContext = usePageContext();
  const { locale, unlocalizedPath } = pageContext;

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolledFromTop(window.pageYOffset >= 50);
          ticking = false; // Reset the ticking flag
        });
        ticking = true; // Set the ticking flag
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Disclosure
        as="nav"
        className={`fixed border border-linegrey w-full bg-white flex justify-between items-center px-4 md:px-12 transition-all duration-500 ${
          scrolledFromTop ? 'h-24 shadow-lg bg-opacity-90' : 'h-24'
        } z-50`}
      >
        <div className="mx-auto w-full px-2">
          <div className="relative flex h-16 items-center justify-between">
            {/* Mobile menu button removed */}
            <div className="flex flex-1 items-center justify-center lg:items-center lg:justify-start">
              {/* logo */}
              <div className="flex shrink-0 items-center">
                <a href="/">
                  <img alt="JVX Studio logo" src={logo} className="h-12" />
                </a>
              </div>
            </div>
            {/* Buttons removed */}
            {/* <div className="absolute inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0">
              <StoreButton />
              <SigninAccountButton />
            </div> */}
          </div>
        </div>

        {/* mobile menu content removed */}
        {/* <DisclosurePanel className="lg:hidden">
          ...
        </DisclosurePanel> */}
      </Disclosure>
      <div className={`h-24 ${scrolledFromTop ? 'h-14' : ''}`} />
    </>
  );
}
